import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/afterSale/index/:id',
  name: ROUTE_NAME.AFTER_SALE,
  meta: {
    title: '售后详情',
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "afterSale" */
      '@/pages/afterSale/index.vue'),
      loading: Loading
    };
  }
}, {
  path: '/afterSale/selete/:orderId',
  name: ROUTE_NAME.SELETE,
  meta: {
    title: '选择售后类型',
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "afterSale" */
      '@/pages/afterSale/seleteSaleStype.vue'),
      loading: Loading
    };
  }
}, {
  path: '/afterSale/replacement/:orderId',
  name: ROUTE_NAME.REPLACEMENT,
  meta: {
    title: '申请换货',
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "afterSale" */
      '@/pages/afterSale/replacement.vue'),
      loading: Loading
    };
  }
}, {
  path: '/afterSale/afterSalesList',
  name: ROUTE_NAME.AFTER_SALE_LIST,
  meta: {
    title: '我的售后',
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "afterSale" */
      '@/pages/afterSale/afterSalesList.vue'),
      loading: Loading
    };
  }
}, {
  path: '/afterSale/slelteSize/:orderId',
  name: ROUTE_NAME.SELETE_SIZE,
  meta: {
    title: '选择尺寸',
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "afterSale" */
      '@/pages/afterSale/seleteSize.vue'),
      loading: Loading
    };
  }
}];